var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#quote_svg__a)",
    d: "M23.175 12.618c-1.183-.926-2.875-.835-3.927.238C7.543 24.797 2 35.76 2 46.057 2 59.456 9.03 69 19.126 69c9.014 0 16.225-7.709 16.225-16.886 0-7.6-5.15-14.153-11.969-16-1.913-.518-3.367-2.41-2.598-4.237 1.592-3.78 4.023-7.584 7.201-11.038 1.253-1.362 1.174-3.534-.283-4.676l-4.527-3.545Zm42.65 0c-1.184-.926-2.876-.835-3.928.238C50.192 24.797 44.65 35.76 44.65 46.057 44.65 59.456 51.68 69 61.775 69 70.79 69 78 61.291 78 52.114c0-7.6-5.15-14.153-11.969-16-1.913-.518-3.367-2.41-2.598-4.237 1.592-3.78 4.023-7.584 7.201-11.038 1.254-1.362 1.174-3.534-.283-4.676l-4.526-3.545Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quote_svg__a",
    x1: 78.928,
    x2: 1.96,
    y1: 39.104,
    y2: 39.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgQuote;